import{css}from'glamor';export default css({':focus':{outline:0}}).toString();